var VideoView = {
	node :null,
	self: this,
	l: {
		"close": TPL.lng("close.movie", "Zamknij film")
	},

	close: function() {
		if (VideoView.idleReset != undefined) {
			clearInterval(VideoView.idleReset);
			VideoView.idleReset = undefined;
		}

		Menu.hideInfoIcon(false);
		SpeechManager.hideWidget(false);
		Volume.lektor.mute(false);

		VideoView.self.media.vnode.pause();
		VideoView.node.removeClass("inph_reveal");
		$(".nav").show();

		VideoView.spot.preventShowingInfo = false;
	},

	showInfo: function(e) {
		var po = $("#invideoview .photo").offset();
		//console.log(po);
		//console.log(VideoView.spot.properties.place.description);
		Menu.showinfowindow({"description": VideoView.spot.properties.place.description, "indicators": [], "properties": {"info_left": (po.left + 50), "info_top": (po.top), "info_width": "700", "info_height": "400"}});

		e.stopPropagation();
	},

	init: function() {
		VideoView.node = $("<div id='invideoview'><div class='bg'></div><div class='photo'><div class='video'></div><div class='clear'></div></div></div>");		

		VideoView.l['close'] = TPL.lng("close.movie", "Zamknij film");
		
		VideoView.node.find(".bg").on("click", function() {
			//VideoView.node.css("visibility", "hidden");
			//VideoView.close();
		});
		//Quality.node.append(TPL.render("quality-main", {}));
		$("#overlay").append(VideoView.node);

		if ( $(window).width() > 500)
			this.closeBtn = $("<div><img src='assets/menu_close.png?123' data-speakgroup='TIPS' data-speak='PLAYER.CLOSE' alt='" + this.l['close'] + "' title='" + this.l['close'] + "' width='50' height='50' style='z-index:99999;position:absolute;right:-25px;top:-25px;cursor:pointer;pointer-events:all;' class='speaks'></div>");
		else
			this.closeBtn = $("<div><img src='assets/menu_close.png?123' data-speakgroup='TIPS' data-speak='PLAYER.CLOSE' alt='" + this.l['close'] + "' title='" + this.l['close'] + "' width='35' height='35' style='z-index:99999;position:absolute;right:5px;top:5px;cursor:pointer;pointer-events:all;' class='speaks'></div>");

		VideoView.node.find(".photo").append(this.closeBtn);

		this.closeBtn.on(Events.pointer.up, function() {
			VideoView.close();
		});

		SpeechManager.enableSpeech("#invideoview", ".speaks", 0, "TOPMENU");

		AppEvent.on(player, "HOTSPOT.STARTLOOKING", VideoView.hotspot);

		AppEvent.on(player, "PLAYER.KEYUP", function(event) {
			if (VideoView.node.hasClass("inph_reveal")) {
				player.blockBackspace = true;
			
				if (event.key == 'Escape' || event.key == 'Backspace') {
					VideoView.close();
				}

				if (event.key == ' ') {
					VideoView.self.media.toggle();
				}
			}
		});

		Tab.add("hotspots", Tab.simpleTab(this.closeBtn, 0), {});
	},

	hotspot: function(spot) {
		//alert("?");
		if (spot.properties.place.place_type == "video" && (spot.properties.place.preview_mode == "1" || spot.properties.place.preview_mode == "2")) {
			spot.noMore();
			spot.preventShowingInfo = true;

			Menu.hideInfoIcon(true);
			SpeechManager.hideWidget(true);
			Volume.lektor.mute(true);

			VideoView.spot = spot;

			var inf = VideoView.node.find(".info");

			if (spot.properties.place.preview_mode == "2") {
				inf.html("");
				inf.show();
				inf.append("<h4>" + spot.properties.place.place_name + "</h4>");
				inf.append("<div>" + spot.properties.place.description + "</div>");
			} else {
				inf.html("");
				inf.hide();
			}

			VideoView.node.find(".photo").removeClass("hphoto");
			VideoView.node.find(".photo").removeClass("vphoto");
			VideoView.node.find(".loader").show();
//			VideoView.node.find(".photo .img").removeClass("loaded");
			
			this.media = new vplayer();
			this.media.fitScreen(200, 150);
			VideoView.node.find(".photo .video").html("");
			VideoView.node.find(".photo .video").append(this.media.embed());
			
			var inode = $("<a href='javascript:void(null);' onclick='VideoView.showInfo(event);' class='ibutton'  title='" + TPL.lng("tips.placeinfo", "Informacja o miejscu") + "'><i class='fa fa-info' aria-hidden='true'></i></a>");
			VideoView.node.find(".screen-ctl").append(inode);


			if (player.offline) {
				spot.properties.place.video = spot.properties.place.video.replace("/data", "data");
			}
			
			this.media.load(spot.properties.place.video);

			this.media.playButton(null);

			this.media.setTitle(spot.properties.place.place_name);

			VideoView.node.addClass("inph_reveal");

			/*
			var img = new Image();
			img.onload = function() {

				if (img.naturalWidth < img.naturalHeight) {
					VideoView.node.find(".photo").removeClass("hphoto");
					VideoView.node.find(".photo").addClass("vphoto");
				} else {
					VideoView.node.find(".photo").removeClass("vphoto");
					VideoView.node.find(".photo").addClass("hphoto");					
				}
				
				VideoView.node.find(".photo .img").attr("src", "https://www.wkraj.pl/data/" + spot.properties.place.place_id + "_photo.jpg");
				VideoView.node.find(".photo .img").addClass("loaded");
				VideoView.node.find(".loader").hide();

				$(".nav").hide();
				VideoView.node.addClass("inph_reveal");
			}
			img.src = "https://www.wkraj.pl/data/" + spot.properties.place.place_id + "_photo.jpg";
			*/

			/*			
			setTimeout(function() {
					spot.noMore();
				}, 350);
			*/

			VideoView.idleReset = setInterval(function() {
				player.cancelIdle();
			}, 2000);
		}
	},
}

PluginManager.add(VideoView);